export const EDIT_TRIAGE_AGENT_CONFIGURATION_TEXT = 'Edit configuration'
export const CREATE_TRIAGE_AGENT_CONFIGURATION_TEXT = 'Configure the agent'
export const CONFIG_FILE_NOT_FOUND_TEXT = 'triage-agent.md file not found'
export const PAUSE_AGENT_TEXT = 'Pause the agent'
export const RESUME_AGENT_TEXT = 'Resume the agent'
export const VIEW_DOCUMENTATION_TEXT = 'View documentation'
export const TRIAGE_AGENT_TITLE = 'Triage agent'
export const TRIAGE_AGENT_DOCS_URL = 'https://docs.github.com/en/copilot'

export type TriageState = 'inactive' | 'active' | 'paused'

export const TRIAGE_BUTTON_TEXT: Record<TriageState, string> = {
  inactive: 'Enable triage',
  active: 'Triage agent',
  paused: 'Triage paused',
}
